import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { RegisterForm } from "@/features/auth/components/RegisterForm";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TRegisterPageProps = {};

export const RegisterPage: FC<TRegisterPageProps> = () => {
  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold">パスワードの再発行</Typography>
      <RegisterForm />
    </Stack>
  );
};
